import React from 'react';
import styled from 'styled-components';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import Option from './MotifOption';

export default function Select(props) {
	const {
		id,
		className,
		placeholder,
		searchPlaceholder,
		multiple,
		value,
		required,
		filter,
		visibleOptions,
		onChange,
		showSelectAllButton,
		selectAll,
		options,
		disabled,
		children
	} = props;
	return (
		<StyledMotifSelect
			id={id}
			className={className}
			placeholder={placeholder}
			searchPlaceholder={searchPlaceholder}
			multiple={multiple}
			value={value}
			required={required}
			filter={filter}
			visibleOptions={visibleOptions}
			onChange={onChange}
			showSelectAllButton={showSelectAllButton}
			selectAll={selectAll}
			disabled={disabled}
		>
			{children
				? children
				: options.map((option) => {
						return <Option key={option} value={option} />;
				  })}
		</StyledMotifSelect>
	);
}

const StyledMotifSelect = styled(MotifSelect)``;
